import { axios } from "../axios";

export const AddComment = (body: any) => {
    return axios.post("comments", body);
}